import { images } from "utils/images"

const REELS = 3
const REELS_REPEAT = 10
const SYMBOLS = 3
const REEL_SYMBOLS = [
  {
    bg: images.cardTypes,
    length: 4,
  },
  {
    bg: images.pairsTypes,
    length: 3,
  },
  {
    bg: images.soundTypes,
    length: 2,
  },
]

const LINES = [
  [
    [0, 1],
    [1, 1],
    [2, 1],
  ], // Middle
]
const CARD_TYPES = {
  IMAGE_IMAGE: {
    value: 0,
    label: "image_image",
    image: require("assets/img/games/memorama/image_image.jpg"),
  },
  IMAGE_AUDIO: {
    value: 1,
    label: "image_audio",
    image: require("assets/img/games/memorama/image_audio.jpg"),
  },
  IMAGE_TEXT: {
    value: 2,
    label: "image_text",
    image: require("assets/img/games/memorama/image_text.jpg"),
  },
  TEXT_AUDIO: {
    value: 3,
    label: "text_audio",
    image: require("assets/img/games/memorama/text_audio.jpg"),
  },
  AUDIO_AUDIO: {
    value: 4,
    label: "audio_audio",
    image: null,
  },
  TEXT_TEXT: {
    value: 5,
    label: "text_text",
    image: null,
  },
  TEXT_TRANSLATION: {
    value: 6,
    label: "text_translation",
    image: null,
  },
}

export { REELS, REELS_REPEAT, SYMBOLS, REEL_SYMBOLS, LINES, CARD_TYPES }
